/** @format */

class HelpModal {
    constructor() {
        this.toggleModal()
    }

    toggleModal = () => {
        const openBtn = document.querySelector('[data-open-modal]');
        const closeBtn = document.querySelector('[data-close-modal]');
        const modal = document.querySelector(`${openBtn.dataset.openModal}`);

        openBtn.addEventListener('click', () =>  modal.showModal());
        closeBtn.addEventListener('click', () =>  modal.close());
    }

    closeEvent = () => {
        let accordion = document.querySelector('.accordion'),
            openHead = accordion.querySelector('button[aria-expanded=true]');

        openHead.addEventListener('click', function () {
            this.setAttribute('aria-expanded', 'false');
            this.closest('.card')
                .querySelector('.show')
                .classList.remove('show');
        });
    };
}
